/**
 * New messages list state machine - replaces useNewMessagesStore (Zustand)
 */
import { setup, assign } from 'xstate'

export interface NewMessagesListContext {
  interactionsWithNewMessages: string[]
}

export type NewMessagesListEvent =
  | { type: 'ADD_INTERACTION'; id: string }
  | { type: 'REMOVE_INTERACTION'; id: string }
  | { type: 'SET_INTERACTIONS'; ids: string[] }
  | { type: 'CLEAR' }

const machineSetup = setup({
  types: {
    context: {} as NewMessagesListContext,
    events: {} as NewMessagesListEvent,
  },
})

export const newMessagesListMachine = machineSetup.createMachine({
  id: 'newMessagesList',
  context: {
    interactionsWithNewMessages: [],
  },
  on: {
    ADD_INTERACTION: {
      actions: assign({
        interactionsWithNewMessages: ({ context, event }) => {
          if (event.type !== 'ADD_INTERACTION') return context.interactionsWithNewMessages
          const ids = context.interactionsWithNewMessages
          return ids.includes(event.id) ? ids : [...ids, event.id]
        },
      }),
    },
    REMOVE_INTERACTION: {
      actions: assign({
        interactionsWithNewMessages: ({ context, event }) => {
          if (event.type !== 'REMOVE_INTERACTION') return context.interactionsWithNewMessages
          return context.interactionsWithNewMessages.filter((i) => i !== event.id)
        },
      }),
    },
    SET_INTERACTIONS: {
      actions: assign({
        interactionsWithNewMessages: ({ event }) =>
          event.type === 'SET_INTERACTIONS' ? event.ids : [],
      }),
    },
    CLEAR: {
      actions: assign({ interactionsWithNewMessages: [] }),
    },
  },
})
